'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const{DataSet:DataSet,Timeline:Timeline}=require('vis-timeline');
const Formatters=require('../../../../dist-es6/client/formatters');
const{ScheduleRowAxisDirectiveController:ScheduleRowAxisDirectiveController}=require('../../../../dist-es6/client/directives/scheduleRowDirective/scheduleRowAxisDirective');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ForecastRowAxisDirective=function(_BaseControllerBacked){_inherits(ForecastRowAxisDirective,_BaseControllerBacked);function ForecastRowAxisDirective(){_classCallCheck(this,ForecastRowAxisDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ForecastRowAxisDirective,[{key:'template',get:function()
{return''}},{key:'objectBindings',get:function()

{return['axisBounds','currentTime']}},{key:'$inject',get:function()

{return['$scope','$timeout','$element','$animate','timeZoneService','scheduleRowScrollingService']}},{key:'controller',get:function()

{return ForecastRowAxisController}}]);return ForecastRowAxisDirective}(BaseControllerBackedDirective);let






ForecastRowAxisController=function(_ScheduleRowAxisDirec){_inherits(ForecastRowAxisController,_ScheduleRowAxisDirec);
function ForecastRowAxisController($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService){_classCallCheck(this,ForecastRowAxisController);var _this2=_possibleConstructorReturn(this,
_ScheduleRowAxisDirec.call(this,$scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService));
_this2._$timeout(function(){
const _forecastTimelineOptions={
timeAxis:{
scale:'hour',
step:2},

format:{
minorLabels:function(date,scale,step){return _this2._momentWithTimeZoneForTimeline(date).format('h:mm')}}};



_this2._timeline.setOptions(_forecastTimelineOptions);
_this2._scheduleRowScrollingService.updateScheduleRowOptions(_forecastTimelineOptions);

_this2._redraw();
});return _this2;
}ForecastRowAxisController.prototype.

_setupWatchers=function _setupWatchers(){var _this3=this;
this._$scope.$watch('controller.axisBounds',function(newAxisBounds,oldAxisBounds){
if(_this3._timeline){
_this3._timeline.setOptions({
min:newAxisBounds.start,
max:newAxisBounds.end});

}

_this3.__updateAxisWindowAndAllScheduleWindows({start:newAxisBounds.start,end:newAxisBounds.end},0);

_this3._redraw();
});

this._$scope.$watch('controller.currentTime',function(newVal,oldVal){return _this3._redraw()});
this._$scope.$on('$destroy',function(){return _this3._scheduleRowScrollingService.setAxis(null)});
};ForecastRowAxisController.prototype.

_updateData=function _updateData(){
const currentTime={
id:'current-time',
start:this.currentTime,
type:'point',
className:'current-time'};


const pastMask={
id:'past-mask',
start:this.axisBounds.start,
end:this.currentTime,
type:'range',
className:'past-mask'};


this._dataset.update([pastMask,currentTime]);
};return ForecastRowAxisController}(ScheduleRowAxisDirectiveController);


module.exports=ForecastRowAxisDirective;
//# sourceMappingURL=forecastRowAxisDirective.js.map
